// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';

// Vue Components
import productTile from '@/components/containers/plp/ProductTile';

// Legacy Plugins
import '@/vendor/owl.carousel.min.js';
import '@/vendor/owl.carousel.plugins.js';
import '@/vendor/acc.paginationsort';
import '@/vendor/jquery.magnific-popup.min';

// Legacy Modules
import productTileModule from '@/modules/ProductTile';
import facets from '@/modules/facets';
import searchResultHandler from '@/modules/searchResultHandler';
import toggler from '@/modules/Toggler';
import slider from '@/modules/slider';
import player from '@/modules/Players';
import videoBackground from '@/modules/VideoBackground';

// Styling
import '@sassRoot/entryPoints/b2c/plp.scss';

class Plp extends Shell {
  preLoadInits() {
    super.preLoadInits();

    // This needs to be refactored once the full B2C PLP page moves to Vue
    window.addEventListener('init-vue-dynamic-content', () => {
      const domElements = document.querySelectorAll('[data-vue-dynamic-content]');
      if (!domElements || !domElements.length) {
        return;
      }

      let store = this.store;

      domElements.forEach((el) => {
        new this.vue({
          store,
          el: el,
          components: {
            productTile,
          },
        });
      });
    });
  }
}

const plp = new Plp({productTile});
plp.preLoadInits();
plp.initializeVue();

// Legacy foundation initialization
$(document).foundation();

$(document).ready(() => {
  plp.globalDocumentReadyInits();
  plp.globalOnLoadInits();

  // Header slider
  const sliders = $('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });

  // Side bar filters
  const togglers = $('[data-toggler]');
  togglers.each((i, t) => {
    toggler($(t));
  });

  // Youtube videos
  player();

  if ($('[data-bg-video]').length) {
    videoBackground($('[data-bg-video]'));
  }

  // Enables the color swatches on the PLP
  if ($('.product-tile').length) {
    productTileModule(document);
  }

  // Facets
  const productList = $('[data-product-list]');
  if (productList.length) {
    facets(productList);
    searchResultHandler(productList);
  }
});
